export default __webpack_public_path__ + "static/media/noNotice.3351cd32.png";